module.exports = __webpack_public_path__ + "static/media/main_logo_white.b596d85f.svg";